import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { setSceneId } from './state/appState';
import { $locale, setLocale } from './state/locale';
import { ViewportProvider } from './context/ViewportContext';
import './main.css';

const setVisibleViewportHeight = () => {
  const vp = window.visualViewport;
  const vvHeight = vp?.height ?? window.innerHeight;
  const height = Math.min(vvHeight, window.innerHeight);
  document.documentElement.style.setProperty('--vvh', `${height * 0.01}px`);

  const bottomOffset = Math.max(
    0,
    window.innerHeight - vvHeight - (vp?.offsetTop ?? 0)
  );
  document.documentElement.style.setProperty(
    '--keyboard-bottom-offset',
    `${bottomOffset}px`
  );
};

setSceneId('main');
setLocale($locale.getState());

const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('Root element "#app" was not found');
}

setVisibleViewportHeight();
window.addEventListener('resize', setVisibleViewportHeight);
window.visualViewport?.addEventListener('resize', setVisibleViewportHeight);
window.visualViewport?.addEventListener('scroll', setVisibleViewportHeight);

ReactDOM.createRoot(rootElement).render(
  <ViewportProvider>
    <App />
  </ViewportProvider>
);
